import { Trophy, Swords, ShoppingBag, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export function ActiveAlerts({ activeDefis, myOrders, challengeData, myActiveChallenges, userId }) {
  if (activeDefis.length === 0 && myOrders.length === 0 && !challengeData?.actif && myActiveChallenges.length === 0) return null;

  return (
    <div className="space-y-2" data-testid="active-alerts">
      {challengeData?.actif && (
        <Link to="/hub" className="flex items-center gap-3 p-3 bg-[#FF6B35]/10 border border-[#FF6B35]/30 rounded-lg">
          <Trophy className="w-5 h-5 text-[#FF6B35] flex-shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-sm text-white font-semibold truncate">Challenge Transformation</p>
            <p className="text-xs text-[#AAAAAA]">{challengeData.date_j0} → {challengeData.date_s12}</p>
          </div>
          <ChevronRight className="w-4 h-4 text-[#FF6B35]" />
        </Link>
      )}
      {activeDefis.map(d => (
        <Link key={d.id} to="/hub?tab=defis" className="flex items-center gap-3 p-3 bg-[#FF00B8]/10 border border-[#FF00B8]/20 rounded-lg">
          <Swords className="w-4 h-4 text-[#FF00B8] flex-shrink-0" />
          <p className="text-sm text-white flex-1 truncate">{d.title}</p>
          <span className="text-xs text-[#AAAAAA]">{d.participants?.length || 0} participants</span>
        </Link>
      ))}
      {myOrders.map(d => {
        const myOrd = (d.orders || []).find(o => o.user_id === userId);
        const qty = myOrd?.quantity || 0;
        const amount = qty * (d.price || 0);
        return (
          <Link key={d.id} to="/hub?tab=plans" className="flex items-center gap-3 p-3 bg-[#FFB800]/10 border border-[#FFB800]/20 rounded-lg">
            <ShoppingBag className="w-4 h-4 text-[#FFB800] flex-shrink-0" />
            <div className="flex-1 min-w-0">
              <p className="text-sm text-white font-semibold truncate">{d.product_name || 'Commande'}</p>
              <p className="text-xs text-[#AAAAAA]">{qty} {d.unit || 'kg'} · {amount.toFixed(0)} XPF</p>
            </div>
            <ChevronRight className="w-4 h-4 text-[#FFB800]" />
          </Link>
        );
      })}
    </div>
  );
}
